

























































































import { library } from '@fortawesome/fontawesome-svg-core';
import { faBan, faCheck, faMasksTheater, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { User, UserList } from '../api';
import DateTime from '../components/DateTime.vue';
import SearchInput from '../components/SearchInput.vue';
import UserRoleBadge from '../components/UserRoleBadge.vue';
import { IToast } from '../store/toast.module';

library.add(faPlus, faBan, faCheck, faMasksTheater, faSearch);

const toast = namespace('toast');
const impersonation = namespace('impersonation');
const user = namespace('user');

@Component({
  components: { DateTime, SearchInput, UserRoleBadge },
})
export default class UserListComponent extends Vue {
  private pollInterval: number | undefined;
  private q = '';

  @user.Getter('users')
  userList!: UserList;

  @user.Action
  loadUsers!: (params?: { q?: string }) => Promise<void>;

  @user.Action
  deleteUser!: (id: string) => Promise<void>;

  @user.Action
  confirmUser!: (id: string) => Promise<void>;

  @toast.Mutation
  private setToast!: (toast: IToast | null) => void;

  @impersonation.Mutation
  private setImpersonating!: (impersonatedUserId: string | null) => void;

  async mounted(): Promise<void> {
    await this.loadUsers({ q: this.q });
    this.pollInterval = setInterval(() => void this.loadUsers({ q: this.q }), 10000);
  }

  beforeDestroy(): void {
    clearInterval(this.pollInterval);
  }

  async onSearchInput(q: string) {
    this.q = q;
    await this.loadUsers({ q: this.q });
  }

  async remove(user: User): Promise<void> {
    const reallyDelete = await this.$bvModal.msgBoxConfirm(`Really delete user ${user.email}`, {
      okVariant: 'danger',
      okTitle: 'Delete',
      cancelVariant: 'outline-dark',
      cancelTitle: 'Cancel',
    });
    if (reallyDelete) {
      await this.deleteUser(user._id);
      await this.loadUsers({ q: this.q });
      this.setToast({ message: `User ${user.email} was deleted.` });
    }
  }

  async confirm(user: User): Promise<void> {
    await this.confirmUser(user._id);
    await this.loadUsers({ q: this.q });
    this.setToast({ message: `User ${user.email} was confirmed.` });
  }

  async impersonate(user: User): Promise<void> {
    this.setImpersonating(user._id);
    await this.$router.push({ path: '/' });
    this.$router.go(0);
  }

  showUserRoleBadge(user: User): boolean {
    return !user.confirmedAt || user.role !== 'user';
  }
}
